import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import {
  RouterOutlet,
  RouterModule,
  ActivatedRoute,
  NavigationEnd,
  Router,
} from '@angular/router';
import { subscriptionManagementRoutes } from './subscription-routing-model';
import { filter } from 'rxjs';

@Component({
  selector: 'app-subscription-management',
  standalone: true,
  templateUrl: './subscription-management.component.html',
  styleUrl: './subscription-management.component.scss',
  imports: [SharedModule, RouterOutlet, RouterModule],
})
export class SubscriptionManagementComponent implements OnInit {
  routeOn: string;
  routes = subscriptionManagementRoutes;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {}

  ngOnInit() {
    const child = this.route.firstChild;

    this.routeOn = child?.snapshot.routeConfig?.path;

    console.log('this.routeOn ', this.routeOn);

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        let child = this.route;

        while (child.firstChild) {
          child = child.firstChild;
        }

        this.routeOn = child.snapshot.routeConfig?.path ?? '';
        console.log('this.routeOn ', this.routeOn);
      });
  }
}
